"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanoramaCircleMarker = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
function PanoramaCircleMarker({ size = 20, color = "#0275d8", focused = false, onClick, onMouseOverChange: setIsOver }) {
    const transition = "all 0.1s ease-out";
    return (0, jsx_runtime_1.jsx)("div", { onMouseEnter: () => setIsOver?.(true), onMouseLeave: () => setIsOver?.(false), children: (0, jsx_runtime_1.jsx)("div", { onClick: onClick, children: (0, jsx_runtime_1.jsxs)("div", { style: {
                    transform: `translateY(-50%) translateX(-50%)`,
                    width: size,
                    height: size,
                    transition,
                    // boxShadow: "1px 1px 2px black",
                    filter: "drop-shadow(1px 1px 1px black)"
                }, children: [(0, jsx_runtime_1.jsx)("div", { style: {
                            width: size,
                            height: size,
                            backgroundColor: "white",
                            borderRadius: "50%",
                            opacity: focused ? 0.7 : 0.6,
                            transition,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }, className: `bg-${color}` }), (0, jsx_runtime_1.jsx)("div", { style: {
                            width: size,
                            height: size,
                            border: `2px solid`,
                            borderColor: color,
                            borderRadius: "50%",
                            position: "absolute",
                            top: 0,
                            transition
                        }, className: `border-${color}` })] }) }) });
}
exports.PanoramaCircleMarker = PanoramaCircleMarker;
